// extracted by mini-css-extract-plugin
export var completionBody = "_jv-2";
export var completionCard = "_jv-0";
export var completionFooter = "_jv-3";
export var completionTitle = "_jv-1";